import { makeStyles } from '@material-ui/core/styles'

export default makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  button: {
    marginTop: 5,
    backgroundColor: theme.palette.secondary.main,
    color: 'secondary',
    '&:hover': { backgroundColor: theme.palette.secondary.main, cursor: 'pointer', opacity: 0.7 }

  },
  buttonInfo: {
    backgroundColor: theme.palette.secondary.main,
    color: 'secondary',
    '&:hover': { backgroundColor: theme.palette.secondary.main, cursor: 'pointer', opacity: 0.7 }

  },
  options: {
    height: theme.spacing(9.75),
    width: theme.spacing(22.5)
  },
  minimapLayer: {
    cursor: 'pointer',
    position: 'relative',
    width: '80px',
    height: '80px',
    backgroundColor: '#fff',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    textAlign: 'center',
    boxSizing: 'border-box',
    boxShadow: '0 0 5px #000'
  }
}))
